import { FC, PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

type Props = PropsWithChildren<unknown>;

export const Portal: FC<Props> = ({ children }) => {
  return createPortal(<div>{children}</div>, document.body);
};
